import React, { useEffect, useState } from 'react'
import { getMessageThreads } from '../../services/api/messages'
import { OrderMessageThread } from '../../model'
import CategoryHeader from '../CategoryHeader'
import DefaultLoader from '../Loaders/DefaultLoader'
import MessageItem from '../MessageItem/MessageItem'

const MessagesWidget: React.FunctionComponent = () => {
    const [loading, setLoading] = useState(false)
    const [messageThreads, setMessageThreads] = useState<[] | any[]>([])

    useEffect(() => {
        const fetchMessageThreads = async () => {
            setLoading(true)
            try {
                const params = { pageSize: 4 }
                const res = await getMessageThreads(params)
                setMessageThreads(Array.isArray(res.items) ? res.items : [])
            } catch (e) {
                console.error(e)
            }
            setLoading(false)
        }
        fetchMessageThreads()
    }, [])

    return (
        <div className='space-y-4 flex-1 h-full'>
            <CategoryHeader title='Nieuwe berichten' iconName='message' />
            <div className='flex flex-col shadow-sm bg-white overflow-hidden border-full rounded-xl'>
                <div>
                    {loading ? (
                        <div className='w-full flex items-center justify-center py-8'>
                            <DefaultLoader />
                        </div>
                    ) : messageThreads.length <= 0 ? (
                        <div className='flex items-center justify-center text-gray-400 py-8 text-sm'>
                            Geen berichten
                        </div>
                    ) : (
                        messageThreads.map((thread: OrderMessageThread) => {
                            return <MessageItem key={thread.id} data={thread} />
                        })
                    )}
                </div>
            </div>
        </div>
    )
}

export default MessagesWidget
